import { TBroadcastTypePickerOptions } from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/broadcast-type-picker/broadcast-type-picker.types';
import { EBroadcastTypes, SessionTypesEnum } from '@/types/session.types';

const getSessionTypeFromSelectedBroadcastType = (selectedType: TBroadcastTypePickerOptions): SessionTypesEnum => {
  if (selectedType === SessionTypesEnum.onDemand) {
    return SessionTypesEnum.onDemand;
  }

  if (selectedType === SessionTypesEnum.breakoutRooms) {
    return SessionTypesEnum.breakoutRooms;
  }

  if (selectedType === EBroadcastTypes.fireside) {
    return SessionTypesEnum.fireside;
  }

  return SessionTypesEnum.broadcast;
};

export default getSessionTypeFromSelectedBroadcastType;
